module.exports = __webpack_public_path__ + "static/media/noun_Empty_2900960.5b0f5285.svg";